import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-barcode-scan-icon',
  templateUrl: './shopping-barcode-scan.component.html'
})
export class ShoppingBarcodeScanComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
